<template>
  <button
    :class="[variant, {
      'disabled': loading || disabled
    }]"
    :type="type"
    @click="onClickButton"
    :disabled="loading || disabled"
  >
    <div v-if="loading" class="loading">
      <div v-for="i in 8" :key="i" :class="[`loading-circle loading-rotate${i}`]"/>
    </div>
    <slot v-else></slot>
  </button>
</template>

<script>
export default {
  name: 'ProaButton',
  props: {
    variant: {
      type: String,
      default: 'light'
    },
    type: {
      type: String,
      default: 'button'
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    to: Object
  },
  methods: {
    onClickButton: function() {
      if (!this.to) return
      this.$router.push(this.to)
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

button {
  display: inline-block;
  text-align: center;
  user-select: none;
  outline: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 8px 20px;
  font-size: 13px;
  border-radius: 0.25rem;
  white-space: nowrap;

  &.primary {
    color: white;
    background-color: $primary-color;

    &:hover:not(.disabled) {
      background-color: $primary-dark-color;
    }
  }

  &.secondary {
    color: white;
    background-color: $secondary-color;

    &:hover:not(.disabled) {
      background-color: $secondary-dark-color;
    }
  }

  &.light {
    color: black;
    background-color: white;
    border: 1px solid $dark-border-color;

    &:hover:not(.disabled) {
      background-color: $light-gray-color;
    }
  }

  &.light-gray {
    color: black;
    background-color: $light-gray-color;
    border: 1px solid $dark-border-color;
  }

  &.outline-primary {
    color: $primary-color;
    border: 1px solid $primary-color;
    background-color: white;
  }

  &.disabled {
    opacity: 0.5;
  }

  &.light .loading-circle {
    animation-name: loading-light;
  }

  .loading {
    position: relative;
    width: 19.5px;
    height: 19.5px;
    margin: auto;
  }

  .loading-circle {
    position: absolute;
    background-color: white;
    height: 3.6px;
    width: 3.4px;
    animation-name: loading;
    animation-duration: 0.522s;
    animation-iteration-count: infinite;
    animation-direction: normal;
  }

  .loading-rotate1 {
    left: 0;
    top: 8px;
    animation-delay: 0.1995s;
  }

  .loading-rotate2{
    left:2px;
    top:2px;
    transform: rotate(45deg);
    animation-delay: 0.256s;
  }

  .loading-rotate3 {
    left: 8px;
    top: 0;
    animation-delay: 0.3225s;
  }

  .loading-rotate4 {
    right: 2px;
    top: 2px;
    transform: rotate(45deg);
    animation-delay: 0.389s;
  }

  .loading-rotate5 {
    right: 0;
    top: 8px;
    animation-delay: 0.4555s;
  }

  .loading-rotate6 {
    right: 2px;
    bottom: 2px;
    transform: rotate(45deg);
    animation-delay: 0.522s;
  }

  .loading-rotate7 {
    left: 8px;
    bottom: 0;
    animation-delay: 0.5885s;
  }

  .loading-rotate8 {
    left: 2px;
    bottom: 2px;
    transform: rotate(45deg);
    animation-delay: 0.645s;
  }

  @keyframes loading {
    0% {
      background-color: #FFFFFF80;
    }

    100%{
      background-color: #FFFFFF;
    }
  }

  @keyframes loading-light {
    0% {
      background-color: #646E6880;
    }

    100%{
      background-color: #646E68;
    }
  }
}
</style>
